<template>
  <ul>
    <li v-for="row of rows" :key="row.id" class="mb-b">
      <ul
        class="grid gap-6"
        :class="{
          'md:grid-cols-2': row.fields.length === 2,
          'md:grid-cols-3': row.fields.length === 3,
          'md:grid-cols-4': row.fields.length === 4,
          'md:grid-cols-5': row.fields.length === 5,
          'md:grid-cols-6': row.fields.length === 6,
        }"
      >
        <li v-for="(field, fieldIndex) of row.fields" :key="fieldIndex">
          <component :is="fieldComponentName(field)" :settings="settings" :field="field" />
        </li>
      </ul>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { fieldComponentName } from '~/assets/formie'

defineProps({
  settings: { type: Object as PropType<Record<string, any>>, required: true },
  rows: { type: Array as PropType<any[]>, required: true },
})
</script>
